import { Stack } from "react-bootstrap";
import { TbCurrencyDirham } from "react-icons/tb";

export default function TableCellCurrency({ value, options }) {
  const formattedValue = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value) || 0);

  const size = options?.size ?? 4;
  let iconSize = "";

  switch (size) {
    case 1:
      iconSize = "text-sm";
      break;
    case 2:
      iconSize = "text-md";
      break;
    case 3:
      iconSize = "text-lg";
      break;
    case 4:
      iconSize = "text-xl";
      break;
    case 5:
      iconSize = "text-2xl";
      break;
    case 6:
      iconSize = "text-3xl";
      break;
    case 7:
      iconSize = "text-5xl";
      break;
    case 8:
      iconSize = "text-6xl";
      break;
    case 9:
      iconSize = "text-7xl";
      break;
    case 10:
      iconSize = "text-8xl";
      break;
    default:
      iconSize = "text-xl";
      break;
  }

  return (
    <Stack gap={1} direction="horizontal">
      <TbCurrencyDirham className={iconSize} />
      <span className="fw-bold">{formattedValue}</span>
    </Stack>
  );
}
